export const ALL_DEVICE_CONSTANT = {
  TITLE: {
    FIXED_ASSET_LEDGER: '固定資産管理台帳',
    BTN_EXPORT: 'エクスポート',
    OUTPUT_INVENTORY_REPORT: '棚卸報告書出力',
    NONE: 'なし',
    DOWNLOAD_CSV: 'CSVダウンロード',
    BTN_OK: 'OK',
    BTN_CANCEL: 'キャンセル',
    BTN_SEARCH: '検索',
    DELETE_CONFIRM_TITLE: '削除確認',
  },
  FILTER_LABEL: {
    COMPANY: '会社',
    STORE: '店舗',
    CATEGORY: '種類',
    DEPARTMENT: '部門',
    STATUS: 'ステータス',
    OWNERSHIP: '所属',
    PHOTO_AVAILABLE: '写真有無',
    ASSET_MANAGEMENT_NO: '資産番号',
    ACQUISITION_MONTH: '取得年月日',
    ACQUISITION_PRICE: '取得価額',
    PAGE_INFO: '件',
    FISCAL_MONTH: '年月',
  },
  TABLE_HEADER: {
    STATUS: '状態',
    ASSET_NUMBER: '資産番号',
    COMPANY: '会社',
    STORE: '店舗',
    CATEGORY: '種類',
    DEPARTMENT: '部門',
    AFFILIATION: '所属',
    ASSET_NAME: '資産名称',
    QUANTITY: '数量',
    ACQUISITION_DATE: '取得年月日',
    USEFUL_LIFE: '耐用年数',
    ACQUISITION_COST: '取得価額',
    OPENING_BOOK_VALUE: '期首帳簿価額',
    LAST_UPDATED_DATE: '最新年月日',
    PHOTO: '写真有無',
    REMARKS: '備考',
    STICKER_REQUEST: 'タグ要求',
  },
  NAME: {
    COMPANY: 'companyCode',
    STORE: 'storeCode',
    CATEGORY: 'assetType',
    DEPARTMENT: 'departmentName',
    OWNERSHIP: 'location',
  },
  EXTRA_FIELD_NAME: {
    FISCAL_MONTH: 'fiscalMonth',
    STATUS: 'status',
    PHOTO_AVAILABLE: 'photoAvailable',
    ASSET_NO: 'assetNo',
    ACQ_DATE_FROM: 'acquisitionDateFrom',
    ACQ_DATE_TO: 'acquisitionDateTo',
    ACQ_PRICE_FROM: 'acquisitionPriceFrom',
    ACQ_PRICE_TO: 'acquisitionPriceTo',
  },
  OPTIONS: {
    STATUS: [
      { label: '全て', value: '' },
      { label: '未確認', value: 'UNCONFIRMED' },
      { label: '確認済', value: 'CONFIRMED' },
      { label: '未使用', value: 'UNUSED' },
      { label: '不記載', value: 'UNLISTED' },
      { label: '移動', value: 'MOVE' },
      { label: '除却', value: 'REMOVE' },
    ],
    PHOTO_AVAILABLE: [
      { label: '全て', value: '' },
      { label: 'あり', value: 'true' },
      { label: 'なし', value: 'false' },
    ],
  },
  PLACEHOLDER: {
    INPUT: '入力',
  },
  MESSAGE: {
    NO_DATA: '該当するデータがありません。',
    EMPTY_SEARCH_CONDITION: '検索条件を入力してください。',
    LOAD_ERROR: 'データの取得に失敗しました。再度お試しください。',
    EXPORT_ERROR: 'エクスポートに失敗しました。再度お試しください。',
    DELETE_ERROR: '削除に失敗しました。再度お試しください。',
    DELETE_SUCCESS: '削除が完了しました。',
    DELETE_CONFIRM: 'この資産を削除してもよろしいですか?',
    DATE_RANGE_INVALID: '取得年月日は From ≤ To の範囲で入力してください。',
    COST_RANGE_INVALID: '取得価額は From ≤ To の範囲で入力してください。',
  },
};

export const HEIGHT_TABLE = 580;
